/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  return (str || '').length >= 5;
}

export function formatPlatform(platform) {
  if (platform === 'ios') {
    return 'iOS';
  } else {
    return 'Android';
  }
}



/**
 * 格式化日期字符串
 * @param {String} fmt 格式：yyyy-MM-dd hh:mm:ss
 * @param {String|Date} date 日期
 * @returns {String} 日期字符串
 */
export function formatDate(fmt, date) {
  if (date === undefined || date === null) {
      date = new Date();
  }
  if (typeof date === 'string') {
      date = new Date(date);
  }
  const o = {
      'M+': date.getMonth() + 1, //月份
      'd+': date.getDate(), //日
      'h+': date.getHours(), //小时
      'm+': date.getMinutes(), //分
      's+': date.getSeconds(), //秒
      'q+': Math.floor((date.getMonth() + 3) / 3), //季度
      S: date.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
      }
  }

  return fmt;
};
